/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateSponsorDto } from '../../models/create-sponsor-dto';
import { SponsorDto } from '../../models/sponsor-dto';

export interface SponsorControllerCreateV1$Params {
      body: CreateSponsorDto
}

export function sponsorControllerCreateV1(http: HttpClient, rootUrl: string, params: SponsorControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<SponsorDto>> {
  const rb = new RequestBuilder(rootUrl, sponsorControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SponsorDto>;
    })
  );
}

sponsorControllerCreateV1.PATH = '/api/v1/sponsor';
